/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import BackIcon from '../Icons/BackIcon';
import ForwardIcon from '../Icons/ForwardIcon';
import Heading from '../Heading';
import Grid from '../Grid';
import { NOOP } from '../../utils/const';

const YearsToShow = new Array(12);
const DecadesToShow = new Array(12);
export const Viste = {
  DAY: 0,
  MONTH: 1,
  YEAR: 2,
  DECADES: 3,
};
const days = ['L', 'M', 'M', 'G', 'V', 'S', 'D'];
const months = ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

function getToday() {
  const today = new Date();
  return { year: today.getFullYear(), month: today.getMonth(), day: today.getDate() };
}

function isToday(date) {
  const today = new Date();
  return date.getFullYear() === today.getFullYear()
    && date.getMonth() === today.getMonth()
    && date.getDate() === today.getDate();
}

function isSelectedDate(date, selectedDate) {
  return date.getFullYear() === selectedDate.getFullYear()
    && date.getMonth() === selectedDate.getMonth()
    && date.getDate() === selectedDate.getDate();
}

function isOutOfRange(date, range) {
  if (!range) return false;
  const mills = date.getTime();
  if (range.from && mills < range.from.getTime()) {
    return true;
  }
  if (range.to && mills > range.to.getTime()) {
    return true;
  }
  return false;
}

function getDateProperties(date, newDate, range) {
  const selected = isSelectedDate(date, newDate);
  const outOfRange = isOutOfRange(newDate, range);
  const today = isToday(newDate);

  return { outOfRange, selected, today };
}

const Days = ({ date: initDate, onChange, range }) => {
  const { month, year, day } = initDate;
  const date = new Date(year, month, day);
  const listaGiorniMeseCorrente = [];
  const numeriGiorniMeseCorrente = new Date(year, month + 1, 0).getDate();
  let primoGiornoDelMese = new Date(year, month, 1).getDay();
  if (primoGiornoDelMese === 0) {
    primoGiornoDelMese = 7;
  }
  for (let i = 1; i < primoGiornoDelMese; i += 1) {
    listaGiorniMeseCorrente.push(null);
  }
  for (let i = 1; i <= numeriGiorniMeseCorrente; i += 1) {
    listaGiorniMeseCorrente.push(i);
  }
  return (
    <Grid fluid>
      <Grid.Row>
        <ul className="datePicker__intestazioneGiorni" aria-label="header">
          {days.map((x, i) => (
            <li
              className="datePicker__dayName"
              key={i} // eslint-disable-line react/no-array-index-key
            >
              {x}
            </li>
          ))}
        </ul>
        <div className="datePicker__clear" />
        <ul className="datePicker__dayList" aria-label="items">
          {listaGiorniMeseCorrente.map((x, i) => {
            const newDate = new Date(year, month, x);
            if (!x) {
              return (
                <li
                  className="datePicker__day--none"
                  key={`none${i}`} // eslint-disable-line react/no-array-index-key
                />
              );
            }
            const { selected, today, outOfRange } = getDateProperties(date, newDate, range);
            const classes = cns(
              'datePicker__day',
              { 'datePicker__day--selected': selected && !outOfRange },
              { 'datePicker__day--today': today },
              { 'datePicker__day--outOfRange': outOfRange },
            );
            return (
              <li
                className={classes}
                key={x}
                role="presentation"
                onClick={() => (outOfRange ? null : onChange({ year, month, day: x }))}
              >
                {x}
              </li>
            );
          })}
        </ul>
      </Grid.Row>
    </Grid>
  );
};

Days.defaultProps = {
  date: null,
  onChange: NOOP,
  range: null,
};

Days.propTypes = {
  /** Data iniziale */
  date: PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    day: PropTypes.number,
  }),
  /** Callback di modifica della data. Il paramentro è un oggetto con {year, month, day} */
  onChange: PropTypes.func,
  range: PropTypes.shape({
    from: PropTypes.any,
    to: PropTypes.any,
  }),
};

const Months = ({ date, onChange, range }) => {
  const { year, month, day } = date;
  return (
    <Grid fluid>
      <Grid.Row>
        {months.map((x, i) => {
          const newDate = { year, month: i, day };
          const outOfRange = isOutOfRange(new Date(year, i, day), range);
          const classes = cns(
            'datePicker__month',
            { 'datePicker__month--selected': i === month },
            { 'datePicker__month--outOfRange': outOfRange },
          );
          return (
            <Grid.Col
              className={classes}
              key={i} // eslint-disable-line react/no-array-index-key
              md={3}
              xs={3}
            >
              <span
                role="presentation"
                onClick={outOfRange ? null : () => onChange(newDate)}
              >
                {x.substr(0, 3)}
              </span>
            </Grid.Col>
          );
        })}
      </Grid.Row>
    </Grid>
  );
};

Months.defaultProps = Days.defaultProps;
Months.propTypes = Days.propTypes;

const Years = ({ date, onChange, range }) => {
  const { year, month, day } = date;
  const decade = year - (year % 10);
  for (let i = -1; i < 11; i += 1) {
    YearsToShow[i + 1] = decade + i;
  }
  return (
    <Grid fluid>
      <Grid.Row>
        {YearsToShow.map((x, i) => {
          const newDate = { year: x, month, day };
          const classes = cns('datePicker__year', { 'datePicker__year--selected': x === year });
          return (
            <Grid.Col
              className={classes}
              key={i} // eslint-disable-line react/no-array-index-key
              md={3}
              xs={3}
            >
              <span
                role="presentation"
                onClick={() => onChange(newDate)}
              >
                {x}
              </span>
            </Grid.Col>
          );
        })}
      </Grid.Row>
    </Grid>
  );
};

Years.defaultProps = Days.defaultProps;
Years.propTypes = Days.propTypes;

const Decades = ({ date, onChange }) => {
  const { year, month, day } = date;
  const century = (year - year % 100);
  for (let i = -1; i < 11; i += 1) {
    DecadesToShow[i + 1] = century + (i * 10);
  }
  return (
    <Grid fluid>
      <Grid.Row>
        {DecadesToShow.map((x, i) => {
          const classes = cns('datePicker__decade', { 'datePicker__decade--selected': year >= x && year < (x + 10) });
          return (
            <Grid.Col
              className={classes}
              key={i} // eslint-disable-line react/no-array-index-key
              md={3}
              xs={3}
            >
              <div
                role="presentation"
                onClick={() => onChange({ year: x, month, day })}
              >
                <span
                  role="presentation"
                  onClick={() => onChange({ year: x, month, day })}
                >
                  {x}
                  -
                  <br />
                  {' '}
                  {x + 10}
                </span>
              </div>
            </Grid.Col>
          );
        })}
      </Grid.Row>
    </Grid>
  );
};

Decades.defaultProps = Days.defaultProps;
Decades.propTypes = Days.propTypes;

const Header = ({ view, date, onChangeView }) => {
  const { month, year } = date;
  switch (view) {
    case Viste.DAY:
      return (
        <Heading
          as="h3"
          className="datePicker__titolo"
          onClick={onChangeView}
        >
          {`${months[month]} ${year}`}
        </Heading>
      );
    case Viste.MONTH:
      return (
        <Heading
          as="h3"
          className="datePicker__titolo"
          onClick={onChangeView}
        >
          {year}
        </Heading>
      );
    case Viste.YEAR:
      return (
        <Heading
          as="h3"
          className="datePicker__titolo"
          onClick={onChangeView}
        >
          {year}
        </Heading>
      );
    case Viste.DECADES:
      return (
        <Heading
          as="h3"
          className="datePicker__titolo"
        >
          {year}
        </Heading>
      );
    default:
      throw new Error('View non definita');
  }
};

Header.defaultProps = {
  date: null,
};

Header.propTypes = {
  date: PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    day: PropTypes.number,
  }),
  onChangeView: PropTypes.func.isRequired,
  view: PropTypes.oneOf([Viste.DAY, Viste.MONTH, Viste.YEAR, Viste.DECADES]).isRequired,
};

function getPreviuosDate(view, date) {
  const { month, year, day } = date;
  switch (view) {
    case Viste.DAY: {
      const newMonth = month - 1;
      if (newMonth >= 0) {
        return { year, month: newMonth, day };
      }
      const newYear = year - 1;
      return { year: newYear, month: 11, day };
    }
    case Viste.MONTH:
      return { year: year - 1, month, day };
    case Viste.YEAR:
      return { year: year - 10, month, day };
    case Viste.DECADES:
      return { year: year - 100, month, day };
    default:
      return date;
  }
}

function getNextDate(view, date) {
  const { month, year, day } = date;
  switch (view) {
    case Viste.DAY: {
      const newMonth = month + 1;
      if (newMonth <= 11) {
        return { year, month: newMonth, day };
      }
      const newYear = year + 1;
      return {
        year: newYear, month: 0, day,
      };
    }
    case Viste.MONTH:
      return { year: year + 1, month, day };
    case Viste.YEAR:
      return { year: year + 10, month, day };
    case Viste.DECADES:
      return { year: year + 100, month, day };
    default:
      return date;
  }
}

const DateComponentChooser = ({
  date: initDate, view: initView, onChange, component, range,
}) => {
  const [view, setView] = useState(initView);
  const [date, setDate] = useState(initDate || getToday());

  return (
    <div className="datePicker__selector">
      <div className="datePicker__intestazione">
        <BackIcon
          className="datePicker__backIcon"
          onClick={() => setDate(getPreviuosDate(view, date))}
        />
        <Header
          view={view}
          date={date}
          onChangeView={() => {
            setView((v) => {
              const r = (v + 1 < Object.keys(Viste).length ? v + 1 : v);
              return r;
            });
          }}
        />
        <ForwardIcon
          className="datePicker__forwardIcon"
          onClick={() => setDate(getNextDate(view, date))}
        />
      </div>
      <hr className="datePicker__separatore" />
      {view === Viste.DAY && <Days date={date} range={range} onChange={component === Viste.DAY ? onChange : NOOP} />}
      {view === Viste.MONTH && (
        <Months
          date={date}
          range={range}
          onChange={component === Viste.MONTH ? onChange : (newDate) => {
            setView(Viste.DAY);
            setDate(newDate);
          }}
        />
      )}
      {view === Viste.YEAR && (
        <Years
          date={date}
          range={range}
          onChange={component === Viste.YEAR ? onChange : (newDate) => {
            setView(Viste.MONTH);
            setDate(newDate);
          }}
        />
      )}
      {view === Viste.DECADES && (
        <Decades
          date={date}
          range={range}
          onChange={component === Viste.DECADES ? onChange : (newDate) => {
            setView(Viste.YEAR);
            setDate(newDate);
          }}
        />
      )}
      <div className="datePicker__clear" />
    </div>
  );
};

DateComponentChooser.Views = Viste;

DateComponentChooser.defaultProps = {
  date: null,
  onChange: NOOP,
  view: Viste.DAY,
  component: Viste.DAY,
  range: undefined,
};

DateComponentChooser.propTypes = {
  /** Data iniziale */
  date: PropTypes.shape({
    year: PropTypes.number,
    month: PropTypes.number,
    day: PropTypes.number,
  }),
  /** Callback di modifica della data. Il paramentro è un oggetto con {year, month, day} */
  onChange: PropTypes.func,
  /** Vista iniziale */
  view: PropTypes.oneOf([
    DateComponentChooser.Views.DAY,
    DateComponentChooser.Views.MONTH,
    DateComponentChooser.Views.YEAR,
    DateComponentChooser.Views.DECADES,
  ]),
  /** Componente della data da selezionare */
  component: PropTypes.oneOf([
    DateComponentChooser.Views.DAY,
    DateComponentChooser.Views.MONTH,
    DateComponentChooser.Views.YEAR,
    DateComponentChooser.Views.DECADES,
  ]),
  range: PropTypes.shape({
    from: PropTypes.any,
    to: PropTypes.any,
  }),
};

export default DateComponentChooser;
